import { Routes, Route } from 'react-router-dom';
import SharedLayout from './SharedLayout';
import Home from '../../pages/Home';
import Projects from '../../pages/Projects';
import Training from '../../pages/Training';
import News from '../../pages/News';
import Publications from '../../pages/Publications';
import People from '../../pages/People';
import Contact from '../../pages/Contact';
import Error from '../../pages/Error/Error';
import Hackathon from '../../pages/Hackathon';
import '../../App.scss';
import React from 'react';
import Profile from '../Profile/Profile';
import ProjectDetails from '../ProjectDetails/ProjectDetails';

function App() {
    return (
        <Routes>
            <Route path='/' element={<SharedLayout />}>
                <Route index element={<Home />} />
                <Route path='projects' element={<Projects />} />
                <Route path='projects/:slug' element={<ProjectDetails />} />
                <Route path='programs' element={<Training />} />
                <Route path='publications' element={<Publications />} />
                <Route path='people' element={<People />} />
                <Route path='people/staff' element={<People />} />
                <Route path='people/students' element={<People />} />
                <Route path='people/staff/:slug' element={<Profile />} />
                <Route path='people/students/:slug' element={<Profile />} />
                <Route path='people/community-partners/:slug' element={<Profile />} />
                <Route path='people/directors/:slug' element={<Profile />} />
                <Route path='people/faculty-affiliates/:slug' element={<Profile />} />
                <Route path='people/postdoctoral-fellows/:slug' element={<Profile />} />
                <Route path='people/collaborators/:slug' element={<Profile />} />
                <Route path='contact' element={<Contact />} />
                <Route path='news' element={<News />} />
                <Route path='hackathon' element={<Hackathon />} />
                <Route path='*' element={<Error />} />
            </Route>
        </Routes>
    );
}

export default App;
